import { CommonGetIDServer, CommonPostIDServer, CommonGet, CommonPost } from '../../../utils/CommonFetch';
import tokenService from '../../Common/tokenDecoder';  
import { toInteger } from 'lodash';

export default {
    getAllRoles,
    saveData,
    editData,
    getAll,
    getGroups,
    getFactories,
    getEntityTypes,
    changePassword,
    resetUser,
    getOperationalEntityByGroupEntityID,
    getAllOperationEntitiesForDropDown,
    getUserFilterData,
    resetUserV2,
    changePasswordV2,
    saveDataV2,
    editDataV2
};



async function getAllRoles(data) {
    var FilterRoleModel = {
        groupID: parseInt(data.groupID),
        operationEntityID: parseInt(data.operationEntityID),
        roleLevel : parseInt(data.roleLevel)
    }
    var response = await CommonPost('/api/Role/FilterRoleByGroupEntityLevel', null,FilterRoleModel);
    console.log("hh",response);
    let roleArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            roleArray[item[1]["aspNetRoleId"]] = item[1]["name"]
        }
    }
    return roleArray;
}

async function getUserFilterData(data) {
    var filterUserModel = {
        groupID: (data.groupID),
        operationEntityID: (data.operationEntityID),
    }
    const response = await CommonPost('/api/User/FilterUser', null, filterUserModel);
    return response.data;
 
}

async function saveData(user) {

    var sentModel =
    {
        id: user.id,
        userName: user.userName,
        passwordHash: user.passwordHash,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        roleId: user.roleId,
        isActive: user.isActive,
        isLocked: user.isLocked,
        groupID: parseInt(user.groupID),
        isFirstLogin: true,
        operationEntityID: parseInt(user.operationEntityID)
    }
    var groupList = await CommonPostIDServer('/Admin/InsertNewTipsUser', null, sentModel);
    return groupList;
}

async function editData(user) {
    var sentModel =
    {
        aspNetUserId: user.aspNetUserId,
        userName: user.userName,
        normalizedUserName: user.normalizedUserName,
        passwordHash: user.passwordHash,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        roleId: user.roleId,
        isLocked: user.isLocked,
        groupID: parseInt(user.groupID),
        operationEntityID: parseInt(user.operationEntityID),
        phoneNumberConfirmed: user.phoneNumberConfirmed,
        twoFactorEnabled: user.twoFactorEnabled,
        lockoutEnabled: user.lockoutEnabled,
        accessFailedCount: user.accessFailedCount,
        isADUser: user.isADUser,
        isActive: user.isActive,
        isFirstLogin: user.isFirstLogin
    }
 
    var groupList = await CommonPostIDServer('/Admin/UpdateTipsUserDetails', null, sentModel);
    return groupList;

}


async function getAll() {

    var users = await CommonGetIDServer('/Admin/GetAllTipsUsers', null);
    return users
}

async function getGroups() {
    let response = await CommonGet('/api/Group/GetAllGroups', null);
    let groupArray = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}


async function getEntityTypes() {
    let response = await CommonGet('/api/OperationEntity/GetAllEntities', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            array[item[1]["entityTypeID"]] = item[1]["entityTypeName"]
        }
    }
    return array;
}

async function getFactories() {
    var factoryArray = []
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null)
    return response.data;
}

async function getOperationalEntityByGroupEntityID(groupId, entityTypeId) {
    var userOperationEntityModel = {
        groupID: groupId.toString(),
        enityTypeID: entityTypeId.toString(),   
    }

    const response = await CommonPost('/api/OperationEntity/GetOperationEntityIDByEntityTypeIDandGroupID', null, userOperationEntityModel);
    let array = []
    for (let item of Object.entries(response.data)) {
        array[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return array;
    
}

async function changePassword(data,id) {
     var changemodel ={
        userId:parseInt(id),
        username:data.userName,
        oldPassword:data.oldPassword,
        newPassword:data.newPassword,
        confirmPassword : data.confirmPassword,
        returnUrl:null,
        redirectUrl:null,
        logoUrl:null,
        companyLogoUrl:null,
        loginTypeText:null
    }
    var result = await CommonPost('/api/IdentityServerClient/ChangePassword', null, changemodel);
    return result;
}


async function resetUser(user,password) {
    var sentModel =
    {
        aspNetUserId: user.aspNetUserId,
        userName: user.userName,
        normalizedUserName: user.normalizedUserName,
        passwordHash: password,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        roleId: user.roleId,
        isLocked: user.isLocked,
        groupID: parseInt(user.groupID),
        operationEntityID: parseInt(user.operationEntityID),
        phoneNumberConfirmed: user.phoneNumberConfirmed,
        twoFactorEnabled: user.twoFactorEnabled,
        lockoutEnabled: user.lockoutEnabled,
        accessFailedCount: user.accessFailedCount,
        isADUser: user.isADUser,
        isActive: user.isActive,
        isFirstLogin: true
    }

    var response = await CommonPost('/api/IdentityServerClient/ResetPassword', null, sentModel);

    return response;
}

async function getAllOperationEntitiesForDropDown(id) {
    var operationEntityArray = [];
    var response = await CommonGet('/api/OperationEntity/GetAllOperationEntities', null);
    for (let item of Object.entries(response.data)) {
        if (item[1] !== undefined && item[1]["groupID"] === parseInt(id) && item[1]["isActive"] === true)
            operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
    return operationEntityArray;
}

async function resetUserV2(user,password) {
    
    var sentModel =
    {
        userID: parseInt(user.aspNetUserId),
        NewPassword: password,
        ModifiedBy: parseInt(tokenService.getUserIDFromToken()),
        ModifiedDate: new Date()
    }
    
    var response = await CommonPost('/api/Auth/ResetPassword', null, sentModel);
    
    return response;
}

async function changePasswordV2(data,id) {
   var userID = parseInt(tokenService.getUserIDFromToken());
    var changemodel ={
       userID:parseInt(userID),
       userName:data.userName,
       userOldPassword:data.oldPassword,
       userNewPassword:data.newPassword,
       userConfirmPassword : data.confirmPassword,
       modifiedBy :parseInt(userID)
   }
  
   console.log('changemodel',changemodel)
   var result = await CommonPost('/api/Auth/changeUserPassword', null, changemodel);
   return result;
}

async function saveDataV2(user) {

    var sentModel =
    {
        // id: user.id,
        // userName: user.userName,
        // passwordHash: user.passwordHash,
        // email: user.email,
        // firstName: user.firstName,
        // lastName: user.lastName,
        // roleId: user.roleId,
        // isActive: user.isActive,
        // isLocked: user.isLocked,
        // groupID: parseInt(user.groupID),
        // isFirstLogin: true,
        // operationEntityID: parseInt(user.operationEntityID)

         aspNetUserId:0,  
         userName: user.userName,   
         firstName: user.firstName,  
         lastName: user.lastName,  
         password: user.passwordHash,  
         groupID: parseInt(user.groupID), 
         operationEntityID: parseInt(user.operationEntityID),  
         aspNetRoleId: parseInt(user.roleId),  
         //RoleName    
         isActive: user.isActive, 
         isLock: user.isLocked,  
         createdBy: parseInt(tokenService.getUserIDFromToken()),  
         createdDate: new Date(),  
         //ModifiedBy  
         //ModifiedDate  
    }

    console.log('sentModel',sentModel)
    var groupList = await CommonPost('/api/Auth/Register', null, sentModel);
    return groupList;
}

async function editDataV2(user) {
    var sentModel =
    {
        aspNetUserId: user.aspNetUserId,
        userName: user.userName,
        normalizedUserName: user.normalizedUserName,
        passwordHash: user.passwordHash,
        email: user.email,
        firstName: user.firstName,
        lastName: user.lastName,
        aspNetRoleId: parseInt(user.roleId),
        isLock: user.isLocked,
        groupID: parseInt(user.groupID),
        operationEntityID: parseInt(user.operationEntityID),
        //phoneNumberConfirmed: user.phoneNumberConfirmed,
        //twoFactorEnabled: user.twoFactorEnabled,
        //lockoutEnabled: user.lockoutEnabled,
        //accessFailedCount: user.accessFailedCount,
        //isADUser: user.isADUser,
        isActive: user.isActive,
        //isFirstLogin: user.isFirstLogin
    }
 
    var groupList = await CommonPost('/api/Auth/UpdateUser', null, sentModel);
    return groupList;

}




